import React, { useEffect } from 'react';
// Types
import { OrganisationProps } from 'types/user';
// Utils
import { getRoleName, isEmptyObject, useSetState, validArray } from 'utils';
import { setOrganisation, setRoles, getorgDescription } from 'utils/user';
// Admin Context
import { rolesList } from 'context/AdminContext/constants';
// Elements
import Button from 'elements/Button';
import { Select } from 'elements/Forms';
import SelectMulti from 'elements/Forms/components/SelectMulti';
import { Modal, ModalHeader, ModalContent, ModalFooter } from 'elements/Modal';
// Config
import RolesMatrix from './RolesMatrix';
// Styles
import styles from './style/siteModal.module.css';

interface OrganisationModalProps {
  active: boolean,
  isdefaultOrganisation: boolean,
  handleCancel: Function,
  handleConfirm: Function,
  organisation: OrganisationProps,
  organisations: {
    orgRef: string,
    orgDescription: string,
  }[],
}

function OrganisationModal({
  active,
  isdefaultOrganisation,
  handleCancel,
  handleConfirm,
  organisation,
  organisations,
}:OrganisationModalProps) {
  const initialState = {
    isdefaultOrganisation: false,
    organisation: {},
    roles: [],
    rolesMatrix: false,
  }
  const [state, setState] = useSetState(initialState);

  useEffect(() => {
    setState({
      isdefaultOrganisation,
      isNewOrganisation: isEmptyObject(organisation),
      organisation: !isEmptyObject(organisation) ? organisation : {},
      roles: !isEmptyObject(organisation) ? organisation.roles : [],
    });
  }, [isdefaultOrganisation, setState, organisation]);

  return (
    <Modal active={active} id="organisation-modal">
      <ModalHeader heading={`${isEmptyObject(organisation) ? 'Add' : 'Edit'} Organisation`} />
      <div className={`${styles.container} ${state.rolesMatrix ? styles.container_matrixActive : ''}`}>
        <ModalContent>
          <div className={styles.content}>
            <Select
              disabled={!isEmptyObject(organisation)}
              handleOnChange={(orgDescription:string) => setState({
                organisation: setOrganisation(organisations, orgDescription),
              })}
              items={validArray(organisations) ? organisations.map(getorgDescription) : []}
              label="Select Organisation"
              name="organisation-select"
              value={state.organisation.orgDescription}
            />
            <div />
            <SelectMulti
              handleOnChange={(e:{ target: HTMLInputElement }) => setState({
                roles: setRoles({ roleName: e.target.value }, state.roles),
              })}
              items={rolesList.map(role => role.toUpperCase())}
              label="Select Roles"
              name="role-select"
              value={(validArray(state.roles) && state.roles.map(getRoleName).join(', ')) || ''}
            />
          </div>
        </ModalContent>
        <div className={`${styles.rolesMatrix} ${state.rolesMatrix ? styles.rolesMatrix_active : ''}`}>
          <RolesMatrix />
        </div>
      </div>
      <footer className={styles.user__modal__footer}>
        <ModalFooter>
          <Button handler={() => handleCancel()}>
            Cancel
          </Button>
          <Button
            btnStyle="secondary"
            disabled={!organisation}
            handler={() => handleConfirm(state)}
          >
            Confirm
          </Button>
        </ModalFooter>
      </footer>
    </Modal>
  );
}

export default OrganisationModal